// extracted by mini-css-extract-plugin
export default {"displayTabs":"style_displayTabs__LhgkV"};